import React from 'react';
import './BalanceCard.scss'; // The SASS stylesheet for this component

const BalanceCard = () => {
  return (
    <div className="balance-card">
      <div className="balance-item">
        <div className="balance-amount">111.00 DDB</div>
        <div className="balance-description">Available tradable amount</div>
      </div>
      <div className="balance-divider"></div>
      <div className="balance-item">
        <div className="balance-amount">1.00</div>
        <div className="balance-description">Freeze amount</div>
      </div>
    </div>
  );
};

export default BalanceCard;
